import {has,get} from 'lodash-es'

export default (http, store, router, Vue) => {
  http.interceptors.request.use(
    config => {
      // Add Authorization header
      let token = store.getters['auth/token']
      if (token) {
        config.headers.Authorization = `Bearer ${token}`
      }

      return config
    },
    error => Promise.reject(error)
  )

  http.interceptors.response.use(
    // response => {
    //   if ( has(response, 'headers.authorization') )
    //   {
    //     store.dispatch('auth/setToken', get(response, 'headers.authorization'))
    //   }
    //   return response
    // },
    response => response,
    error => {
      let { config, response } = error

      if (!has(config, 'params.uuid') && [404, 405].indexOf(response.status) > -1) {
        Vue.$notify.error('The API endpoint you were looking for could not be found.')
      }

      if ([401].indexOf(response.status) > -1) {
        store.dispatch('auth/logout')
        router.push({
          name: '/login',
          query: {
            redirect: router.currentRoute.fullPath
          }
        })
      }

      return Promise.reject(error)
    }
  )
}
